import { Tabs } from 'antd'
import { t } from 'i18next'
import React from 'react'
import OpenChatsTab from './OpenChatsTab'
import AllChatsTab from './AllChatsTab'

export default function ChatsPage () {
  return (
    <Tabs
      defaultActiveKey='open'
      items={[
        {
          label: t('Admin.ChatsPage.tab.open'),
          key: 'open',
          children: <OpenChatsTab />
        },
        {
          label: t('Admin.ChatsPage.tab.all'),
          key: 'all',
          children: <AllChatsTab />
        }
      ]}
    />
  )
}
